import React from 'react';
import HistoryLogListPageContainer from './HistoryLogListPageContainer';

export class HistoryLogListPage extends React.Component{
    render(){
        return(
            <HistoryLogListPageContainer {...this.props}/>
        )
    }
}